import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Select from 'components/Select'
import * as FileSaver from 'file-saver'
import * as JSZip from 'jszip'
import React, { Fragment, useState } from 'react'
import { COLORS } from 'theme'
import {
  CountDiv,
  PaddedDiv,
  RoleFlex,
  RoleInfoFlex,
  TitleDiv,
} from '../InterviewerDrawer/style'
import RolesTable from '../RolesTable/index'

const CandidateDetailDrawer = ({
  isCandDrawer,
  setIsCandDrawer,
  canditateDocumentList,
  getCandidateDocumentsList,
  driveId,
  roleId,
  getCandidateDocumentsMetrices,
  setLoading,
}) => {
  const onClose = () => {
    setIsCandDrawer(false)
    setSelectedOption('')
  }
  const [selectedOption, setSelectedOption] = useState(null)
  const [matrices, setMatrices] = useState([])
  const [selectedRows, setSelectedRows] = useState(true)
  const [documentType, setDocumentType] = useState('')
  const [selectedCandidates, setSelectedCandidates] = useState([])

  const optionData = [
    {
      value: 'IDENTITY_PROOF',
      label: 'ID Proof',
    },
    {
      value: 'ADDRESS',
      label: 'Address Proof',
    },
    {
      value: 'EMPLOYMENT_PROOF',
      label: 'Experience Certificate',
    },
    {
      value: 'EDUCATION',
      label: 'Education Certificate',
    },
    {
      value: 'OTHER_DOCUMENT',
      label: 'Other Document',
    },
    {
      value: '',
      label: 'All Documentation',
    },
  ]

  const getMatricesList = async () => {
    setLoading(true)
    let response = await getCandidateDocumentsMetrices({
      driveId: driveId,
      roleId: roleId,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      setMatrices(response?.data?.data || [])
      setLoading(false)
    }
  }

  const documentsUrls = selectedCandidates?.map(candidate => {
    const document = candidate.student?.student_document_map?.map(
      item => item.doc?.url
    ) // Assuming you want the first document URL
    return document
  })
  const flattenedArray = []?.concat(...documentsUrls)
  const student = flattenedArray?.filter(document => document !== undefined)
  const downloadAsZip = async () => {
    const zip = new JSZip()

    let urls = student.filter(url => url !== 'ddd')
    for (let index = 0; index < urls.length; index++) {
      const url = urls[index]
      const filename = `document_${index + 1}.pdf` // You can customize the filename here
      try {
        let response = await fetch(url)
        let blob = await response.blob()
        zip.file(filename, blob)
      } catch (error) {
        console.error('Error downloading document:', error)
      }
    }
    zip.generateAsync({ type: 'blob' }).then(content => {
      FileSaver.saveAs(content, 'documents.zip')
    })
  }

  const content = () => {
    return (
      <div>
        <PaddedDiv column>
          <RoleInfoFlex row spaceBetween>
            <Fragment>
              <RoleFlex column>
                <CountDiv>{matrices?.requestedCandidates}</CountDiv>
                <TitleDiv>Requested Candidates</TitleDiv>
              </RoleFlex>
              <RoleFlex column>
                <CountDiv>{matrices?.candidateDocUploaded}</CountDiv>
                <TitleDiv>Uploaded</TitleDiv>
              </RoleFlex>
              <RoleFlex column border>
                <CountDiv>{matrices?.candidateDocUploadPending}</CountDiv>
                <TitleDiv>Pending</TitleDiv>
              </RoleFlex>
            </Fragment>
          </RoleInfoFlex>
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ width: '37%' }}>
              <Select
                style={{ width: '100%', marginTop: '20px' }}
                OptionData={optionData}
                nameParam="label"
                valueParam="value"
                backgroundcolor={COLORS.GREY_T_98}
                defaultValue="All Documentation"
                onChange={value => setSelectedOption(value)}
              />
            </div>
            <div>
              {!selectedRows ? (
                <Button.Secondary
                  height={'38px'}
                  text={'Download All'}
                  onClick={downloadAsZip}
                />
              ) : null}
            </div>
          </div>

          <div>
            <RolesTable
              selectedOption={selectedOption}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              canditateDocumentList={canditateDocumentList}
              getCandidateDocumentsList={getCandidateDocumentsList}
              driveId={driveId}
              roleId={roleId}
              downloadAsZip={downloadAsZip}
              setDocumentType={setDocumentType}
              documentType={documentType}
              optionData={optionData}
              setSelectedCandidates={setSelectedCandidates}
              selectedCandidates={selectedCandidates}
              getMatricesList={getMatricesList}
            />
          </div>
        </PaddedDiv>
      </div>
    )
  }

  return (
    <div>
      <Drawer
        width="65%"
        title={'Candidate Documents '}
        placement="right"
        visible={isCandDrawer}
        content={content()}
        onClose={onClose}
        closable
      />
    </div>
  )
}

export default CandidateDetailDrawer
